/* Lux Signage Co. Make webhook delivery for shared partner and quote forms. */
(function () {
  'use strict';

  var WEBHOOK_URL = 'https://hook.us2.make.com/54afdkupzsfxtneiqspu5z5ir7eova3w';
  var WEBHOOK_VERSION = 'lux_site_v1';
  var ATTRIBUTION_STORAGE_KEY = 'lux_attribution_v1';
  var MAX_FILE_BYTES = 4.5 * 1024 * 1024;
  var REQUEST_TIMEOUT_MS = 30000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function onReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function applyRequestedPageAdjustments() {
    if (!document.getElementById('lux-requested-page-adjustments')) {
      var style = document.createElement('style');
      style.id = 'lux-requested-page-adjustments';
      style.textContent = [
        '#lux-resource-center .lux-res-head > p,',
        '#lux-resource-center .lux-res-group-description{display:none!important}',
        '#lux-resource-center .lux-res-head{margin-bottom:24px!important}',
        '#lux-resource-center .lux-res-head h2{margin-bottom:0!important}',
        '#lux-resource-center .lux-res-group-top{padding-bottom:14px!important}',
        '#lux-resource-center .lux-res-items{padding-top:14px!important}'
      ].join('');
      document.head.appendChild(style);
    }

    var whyHeadline = document.querySelector('#lux-why-page .lux-why-hero h1 span');
    if (whyHeadline && /stronger production partner/i.test(whyHeadline.textContent || '')) {
      whyHeadline.textContent = 'a dependable production partner.';
    }
  }

  function formType(form) {
    if (form.dataset.luxForm === 'quote' || /quote/i.test(form.id || '')) return 'quote';
    return 'partner';
  }

  function namedValue(form, name) {
    if (!form || !form.elements || typeof form.elements.namedItem !== 'function') return '';
    var field = form.elements.namedItem(name);
    if (!field || typeof field.value === 'undefined') return '';
    return String(field.value || '').trim();
  }

  function trackedValue(form, attribute, key) {
    var field = form.querySelector('[' + attribute + '="' + key + '"]');
    return field ? String(field.value || '').trim() : '';
  }

  function projectFileInput(form) {
    return form ? form.querySelector('[data-lux-project-file]') : null;
  }

  function projectFile(form) {
    var input = projectFileInput(form);
    return input && input.files && input.files[0] ? input.files[0] : null;
  }

  function fileValidationMessage(form, type) {
    if (type !== 'quote') return '';
    var file = projectFile(form);
    if (!file) return 'Please add a project file before sending your quote request.';
    if (!/\.(ai|eps|pdf|svg|png|jpe?g)$/i.test(file.name || '')) {
      return 'Please upload an AI, EPS, PDF, SVG, PNG, JPG, or JPEG file.';
    }
    if (file.size > MAX_FILE_BYTES) {
      return 'The uploaded file must be 4.5 MB or smaller. Please choose a smaller file or email it to support@luxsignage.co.';
    }
    return '';
  }

  function clearClientError(form) {
    form.querySelectorAll('[data-lux-webhook-error]').forEach(function (error) { error.remove(); });
  }

  function showClientError(form, message) {
    clearClientError(form);
    var error = document.createElement('div');
    error.className = 'lux-form-error';
    error.setAttribute('role', 'alert');
    error.setAttribute('tabindex', '-1');
    error.setAttribute('data-lux-webhook-error', 'true');
    error.textContent = message;
    form.insertBefore(error, form.firstChild);
    error.focus();
  }

  function readAttribution() {
    var attribution = {};
    try { attribution = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || '{}') || {}; } catch (error) {}
    var params = null;
    try { params = new URL(window.location.href).searchParams; } catch (error) {}
    UTM_KEYS.forEach(function (key) {
      var current = params ? params.get(key) : '';
      if (current) attribution[key] = current;
      else if (typeof attribution[key] !== 'string') attribution[key] = '';
    });
    if (!attribution.landing_page) attribution.landing_page = window.location.href;
    if (!attribution.referrer) attribution.referrer = document.referrer || '';
    return attribution;
  }

  function append(payload, key, value) {
    payload.append(key, value == null ? '' : String(value));
  }

  function buildPayload(form, type, submissionId) {
    var payload = new FormData();
    var attribution = readAttribution();
    var file = projectFile(form);

    append(payload, 'webhook_version', WEBHOOK_VERSION);
    append(payload, 'submission_id', submissionId);
    append(payload, 'submitted_at', new Date().toISOString());
    append(payload, 'form_type', type === 'quote' ? 'quote_request' : 'partner_application');
    append(payload, 'form_name', type === 'quote' ? 'Quote Request' : 'Partner Application');
    append(payload, 'form_context', form.dataset.luxFormContext || '');

    append(payload, 'name', namedValue(form, 'contact[name]'));
    append(payload, 'business_name', namedValue(form, 'contact[Business Name]'));
    append(payload, 'email', namedValue(form, 'contact[email]'));
    append(payload, 'phone', namedValue(form, 'contact[phone]'));
    append(payload, 'business_type', namedValue(form, 'contact[Business Type]'));
    append(payload, 'sign_style', namedValue(form, 'contact[Sign Style]') || trackedValue(form, 'data-lux-context-field', 'sign_style'));
    append(payload, 'approx_size', namedValue(form, 'contact[Approx Size]'));
    append(payload, 'notes', namedValue(form, 'contact[body]'));

    append(payload, 'landing_page_url', attribution.landing_page || '');
    append(payload, 'submission_page_url', window.location.href);
    append(payload, 'source_page', window.location.pathname);
    append(payload, 'page_title', document.title);
    append(payload, 'referrer', attribution.referrer || document.referrer || '');
    UTM_KEYS.forEach(function (key) { append(payload, key, attribution[key] || ''); });

    append(payload, 'product_handle', trackedValue(form, 'data-lux-context-field', 'product_handle'));
    append(payload, 'product_title', trackedValue(form, 'data-lux-context-field', 'product_title'));
    append(payload, 'variant_id', trackedValue(form, 'data-lux-context-field', 'variant_id'));
    append(payload, 'trigger_location', trackedValue(form, 'data-lux-context-field', 'trigger_location'));

    append(payload, 'file_included', file ? 'true' : 'false');
    append(payload, 'file_name', file ? file.name : '');
    append(payload, 'file_type', file ? file.type : '');
    append(payload, 'file_size_bytes', file ? file.size : '');
    if (file) payload.append('file', file, file.name);

    return payload;
  }

  function ensureHiddenField(form, name, value) {
    var field = form.elements && typeof form.elements.namedItem === 'function' ? form.elements.namedItem(name) : null;
    if (!field || field.tagName !== 'INPUT') {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value == null ? '' : String(value);
  }

  function restoreForm(form) {
    delete form.dataset.luxWebhookSubmitting;
    delete form.dataset.luxSubmitting;
    delete form.dataset.luxWebhookNative;
    form.querySelectorAll('[data-lux-disabled-for-shopify]').forEach(function (field) {
      field.disabled = false;
      delete field.dataset.luxDisabledForShopify;
    });
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (button.dataset.luxOriginalText) button.textContent = button.dataset.luxOriginalText;
    }
  }

  function nativeShopifySubmit(form, deliveryState, submissionId) {
    ensureHiddenField(form, 'contact[Webhook Submission ID]', submissionId);
    ensureHiddenField(form, 'contact[Webhook Delivery]', deliveryState);
    var fileInput = projectFileInput(form);
    if (fileInput) {
      fileInput.disabled = true;
      fileInput.dataset.luxDisabledForShopify = 'true';
    }
    form.dataset.luxWebhookNative = 'true';
    window.HTMLFormElement.prototype.submit.call(form);
  }

  function postToWebhook(form, type, submissionId) {
    if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') {
      return Promise.reject(new Error('Webhook delivery is not supported by this browser.'));
    }
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS) : null;
    var options = {
      method: 'POST',
      body: buildPayload(form, type, submissionId),
      mode: 'no-cors',
      credentials: 'omit',
      cache: 'no-store',
      redirect: 'follow',
      referrerPolicy: 'strict-origin-when-cross-origin'
    };
    if (controller) options.signal = controller.signal;
    return window.fetch(WEBHOOK_URL, options).then(function () {
      return 'request_completed';
    }).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-lux-form], #lux-popup-partner-form, #lux-inline-partner-form, #lux-popup-quote-form')) return;
    if (form.dataset.luxWebhookNative === 'true') return;

    var type = formType(form);
    var fileError = fileValidationMessage(form, type);
    event.preventDefault();

    if (fileError) {
      event.stopImmediatePropagation();
      showClientError(form, fileError);
      restoreForm(form);
      return;
    }
    if (form.dataset.luxWebhookSubmitting === 'true') return;

    clearClientError(form);
    form.dataset.luxWebhookSubmitting = 'true';

    Promise.resolve().then(function () {
      var submissionId = form.dataset.luxEventId || ('lux_' + type + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10));
      ensureHiddenField(form, 'contact[Webhook Submission ID]', submissionId);
      return postToWebhook(form, type, submissionId).then(function (deliveryState) {
        nativeShopifySubmit(form, deliveryState, submissionId);
      }).catch(function () {
        nativeShopifySubmit(form, 'request_failed_shopify_backup_used', submissionId);
      });
    });
  }

  function initialize() {
    applyRequestedPageAdjustments();
    if (document.documentElement.dataset.luxWebhookReady === 'true') return;
    document.documentElement.dataset.luxWebhookReady = 'true';
    document.addEventListener('submit', handleSubmit, true);
  }

  onReady(initialize);
  document.addEventListener('shopify:section:load', applyRequestedPageAdjustments);
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-lux-form]').forEach(restoreForm);
  });
})();
